import React, { useEffect } from 'react';
import gsap from 'gsap';
import { ELEMENTS } from '../data';
import iconMap from '../iconMap';

export const ElementInfoModal = ({ element, onClose }) => {
  useEffect(() => {
    const tl = gsap.timeline();
    
    tl.fromTo('.element-info-area', 
      { backgroundColor: 'rgba(255, 255, 255, 1)' },
      { 
        backgroundColor: 'rgba(255, 255, 255, 0)',
        duration: 0.45,
        ease: 'power2.out'
      }
    );

    tl.from('.element-info-content', {
      y: -20,
      scale: 0,
      opacity: 0,
      duration: 0.3,
      ease: 'back.out(1.7)'
    });
  }, []);

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="element-info-area w-full py-8 bg-gradient-to-r from-transparent via-black/80 to-transparent">
        <div className="element-info-content max-w-2xl mx-auto p-6 bg-gray-900/90 rounded-2xl">
          <h3 className="text-2xl font-bold text-blue-300 mb-4">Element Information</h3>
          <table className="w-full text-sm text-left text-gray-300 mb-6 border-collapse">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="px-4 py-2">Element</th>
                <th className="px-4 py-2">Strong Against</th>
                <th className="px-4 py-2">Weak Against</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(ELEMENTS).map(([key, data]) => (
                <tr key={key} className={`border-b border-gray-700 ${element === key ? 'bg-blue-900/30' : ''}`}>
                  <td className={`px-4 py-2 ${ELEMENTS[key].color} flex items-center`}>
                    {React.createElement(iconMap[key], { size: 20, className: "mr-2" })}
                    {data.name}
                  </td>
                  <td className="px-4 py-2">{data.strength.map(e => (
                    <span key={e} className="flex items-center inline-block mr-2">
                      {React.createElement(iconMap[e], { size: 16, className: `${ELEMENTS[e].color} mr-1` })}
                      {ELEMENTS[e].name}
                    </span>
                  ))}</td>
                  <td className="px-4 py-2">{data.weakness.map(e => (
                    <span key={e} className="flex items-center inline-block mr-2">
                      {React.createElement(iconMap[e], { size: 16, className: `${ELEMENTS[e].color} mr-1` })}
                      {ELEMENTS[e].name}
                    </span>
                  ))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            onClick={onClose}
            className="px-8 py-2 rounded-full bg-white text-black font-bold hover:bg-gray-100 transition-colors"
            style={{ fontFamily: 'Norse' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
